module.exports = __webpack_public_path__ + "static/media/contact.7a61bd54.png";